import { Component, ErrorInfo } from 'react';

import { DistributorContext } from '@mews-distributor/common';

interface ErrorBoundaryProps {
    children: React.ReactNode;
    fallback: React.ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
    state: State = {
        hasError: false,
    };

    declare context: React.ContextType<typeof DistributorContext>;
    static contextType = DistributorContext;

    static getDerivedStateFromError(_: Error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.context.loggerService.log('error-boundary-error', 'ErrorBoundary component did catch', {
            error,
            errorInfo,
        });
    }

    render() {
        if (this.state.hasError) {
            // Render fallback
            return this.props.fallback;
        }

        return this.props.children;
    }
}
